import { createPersistValue } from '@ui/features/Trade/store/createPersistValue';
import { OrderType } from '@ui/types/trade';

export const useOrderType = createPersistValue<OrderType>(
  'trade.orderType',
  OrderType.MARKET,
);